import axios from "axios";
import { CreateCorralPayload, ManualCorralAssignPayload } from "../types/corral.types";

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const getCorrals = (event_id: string, distance?: string) =>
  api.get("EventManagement/corral", {
    params: {
      event_id,
      ...(distance ? { distance } : {}),
    },
  });

export const createCorral = (payload: CreateCorralPayload) =>
  api.post("EventManagement/corral", payload);

export const updateCorral = (id: string, payload: Partial<CreateCorralPayload>) =>
  api.put(`EventManagement/corral/${id}`, payload);

export const deleteCorral = (id: string) =>
  api.delete(`EventManagement/corral/${id}`);

export const autoAssignCorral = (event_id: string, distance: string) =>
  api.post("EventManagement/corral/auto-assign", { event_id, distance });

export const manualAssignCorral = (payload: ManualCorralAssignPayload) =>
  api.post("EventManagement/corral/manual-assign", payload);

export const unassignCorral = (registration_id: string) =>
  api.post("EventManagement/corral/unassign", { registration_id });

export const getCorralSummary = (event_id: string, distance?: string) =>
  api.get("EventManagement/corral/summary", {
    params: {
      event_id,
      ...(distance ? { distance } : {}),
    },
  });

export const getCorralAssignments = (
  event_id: string,
  distance?: string,
  corral_id?: string,
  page = 1,
  per_page = 50,
) =>
  api.get("EventManagement/corral/assignments", {
    params: {
      event_id,
      ...(distance ? { distance } : {}),
      ...(corral_id ? { corral_id } : {}),
      page,
      per_page,
    },
  });

export const getRegistrationsWithBib = (
  event_id: string,
  distance: string,
  page = 1,
  limit = 500,
  filters?: any
) =>
  api.get("core/Order/Registration", {
    params: {
      event_id,
      with: ["order", "ticket"],
      limit,
      page,
      "filter[ticket.distance][eq]": distance,
      ...filters,
    },
  });

export const getEventBibRanges = (event_id: string, distance?: string) =>
  api.get("EventManagement/bib-range", {
    params: { event_id, ...(distance ? { distance } : {}) },
  });

const corralService = {
  getCorrals,
  createCorral,
  updateCorral,
  deleteCorral,
  autoAssignCorral,
  manualAssignCorral,
  unassignCorral,
  getCorralSummary,
  getCorralAssignments,
  getRegistrationsWithBib,
  getEventBibRanges,
};

export default corralService;
